"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableRowActions = exports.TableCell = exports.TableRow = exports.TableBody = exports.TableHeader = exports.Table = void 0;
var react_1 = __importStar(require("react"));
var Asc_1 = require("../components/icons/Asc");
var Desc_1 = require("../components/icons/Desc");
var Sorting_1 = require("../components/icons/Sorting");
var system_1 = require("../system");
var utils_1 = require("../utils");
var TableContext = react_1.default.createContext(null);
var useTableStyles = (0, system_1.makeStyles)(function () { return ({
    table: {
        borderCollapse: 'collapse',
    },
}); });
function Table(_a) {
    var children = _a.children, stickyHeader = _a.stickyHeader, className = _a.className, props = __rest(_a, ["children", "stickyHeader", "className"]);
    var contextValue = (0, react_1.useMemo)(function () { return ({
        stickyHeader: stickyHeader,
    }); }, [stickyHeader]);
    var table = useTableStyles().table;
    return (react_1.default.createElement("table", __assign({ className: (0, utils_1.cn)(table, className) }, props),
        react_1.default.createElement(TableContext.Provider, { value: contextValue }, children)));
}
exports.Table = Table;
function TableHeader(_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return react_1.default.createElement("thead", __assign({}, props), children);
}
exports.TableHeader = TableHeader;
function TableBody(_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return react_1.default.createElement("tbody", __assign({}, props), children);
}
exports.TableBody = TableBody;
var RowContext = react_1.default.createContext(null);
var useRowStyles = (0, system_1.makeStyles)(function (theme) {
    return {
        tableRow: {
            backgroundColor: theme.go.schemes.colors.system.BgMain,
        },
        selectedRow: {
            '$tableRow&': {
                backgroundColor: theme.go.schemes.colors.system.SubtleAccent,
            },
        },
        interactiveRow: {
            cursor: 'pointer',
        },
    };
});
function TableRow(_a) {
    var children = _a.children, selected = _a.selected, className = _a.className, onClick = _a.onClick, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, hover = _a.hover, props = __rest(_a, ["children", "selected", "className", "onClick", "onMouseEnter", "onMouseLeave", "hover"]);
    var _b = useRowStyles(), tableRow = _b.tableRow, selectedRow = _b.selectedRow, interactiveRow = _b.interactiveRow;
    var _c = __read((0, react_1.useState)(false), 2), hovered = _c[0], setHover = _c[1];
    var onMouseEnterHandler = (0, react_1.useCallback)(function (e) {
        onMouseEnter === null || onMouseEnter === void 0 ? void 0 : onMouseEnter(e);
        setHover(true);
    }, [onMouseEnter]);
    var onMouseLeaveHandler = (0, react_1.useCallback)(function (e) {
        onMouseLeave === null || onMouseLeave === void 0 ? void 0 : onMouseLeave(e);
        setHover(false);
    }, [onMouseLeave]);
    var context = (0, react_1.useMemo)(function () {
        return {
            hover: hover || hovered,
        };
    }, [hover, hovered]);
    return (react_1.default.createElement("tr", __assign({ className: (0, utils_1.cn)(className, tableRow, selected ? selectedRow : undefined, onClick ? interactiveRow : undefined), onClick: onClick, onMouseEnter: onMouseEnterHandler, onMouseLeave: onMouseLeaveHandler }, props),
        react_1.default.createElement(RowContext.Provider, { value: context }, children)));
}
exports.TableRow = TableRow;
var useCellStyles = (0, system_1.makeStyles)(function (theme) {
    return {
        tableCell: {
            boxShadow: "inset 0px -1px 0px ".concat(theme.go.schemes.colors.system.Divider),
        },
        tableHeadCell: __assign(__assign({}, theme.go.mixins.typography.Subhead), { backgroundColor: theme.go.schemes.colors.system.BgMain, padding: 12, whiteSpace: 'nowrap' }),
        tableHeadCellContent: {
            display: 'inline-flex',
            alignItems: 'center',
            flexWrap: 'nowrap',
        },
        tableBodyCell: __assign(__assign({}, theme.go.mixins.typography.Body), { padding: '14px 12px' }),
        icon: {
            width: 16,
            height: 16,
            marginLeft: theme.go.schemes.spacing.units.XS,
        },
        sortableCell: {
            cursor: 'pointer',
        },
        hoveredCell: {
            // theme.go.mixins.effects.Hovered не работает для таблиц в ie11
            // там криво считаются высоты ячеек
            backgroundColor: "rgba(".concat(theme.go.schemes.effects.overlayColor, ",0.04)"),
        },
        stickyCell: {
            position: 'sticky',
            top: 0,
            zIndex: 2,
        },
    };
});
function TableCell(_a) {
    var variant = _a.variant, _b = _a.align, align = _b === void 0 ? 'left' : _b, _c = _a.verticalAlign, verticalAlign = _c === void 0 ? 'top' : _c, className = _a.className, children = _a.children, sortable = _a.sortable, sortDirection = _a.sortDirection, onSort = _a.onSort, id = _a.id, props = __rest(_a, ["variant", "align", "verticalAlign", "className", "children", "sortable", "sortDirection", "onSort", "id"]);
    var component = variant === 'head' ? 'th' : 'td';
    var _d = useCellStyles(), tableCell = _d.tableCell, tableHeadCell = _d.tableHeadCell, tableHeadCellContent = _d.tableHeadCellContent, tableBodyCell = _d.tableBodyCell, icon = _d.icon, sortableCell = _d.sortableCell, hoveredCell = _d.hoveredCell, stickyCell = _d.stickyCell;
    var rowContext = (0, react_1.useContext)(RowContext);
    var tableContext = (0, react_1.useContext)(TableContext);
    var content = (react_1.default.createElement(react_1.default.Fragment, null,
        children,
        sortable ? (sortDirection === 'asc' ? (react_1.default.createElement(Asc_1.AscIcon, { className: icon })) : sortDirection === 'desc' ? (react_1.default.createElement(Desc_1.DescIcon, { className: icon })) : (react_1.default.createElement(Sorting_1.SortingIcon, { className: icon }))) : undefined));
    var onClick = (0, react_1.useCallback)(function () {
        if (id) {
            onSort === null || onSort === void 0 ? void 0 : onSort(id, sortDirection === 'desc' ? 'asc' : 'desc');
        }
    }, [id, onSort, sortDirection]);
    return react_1.default.createElement(component, __assign(__assign({}, props), { align: align, valign: variant === 'head' ? 'middle' : verticalAlign, className: (0, utils_1.cn)(className, tableCell, variant === 'head' ? tableHeadCell : tableBodyCell, sortable ? sortableCell : undefined, (rowContext === null || rowContext === void 0 ? void 0 : rowContext.hover) && variant !== 'head' ? hoveredCell : undefined, (tableContext === null || tableContext === void 0 ? void 0 : tableContext.stickyHeader) && variant === 'head' ? stickyCell : undefined) }), variant === 'head' ? (react_1.default.createElement("div", { className: tableHeadCellContent, onClick: onClick }, content)) : (content));
}
exports.TableCell = TableCell;
var useActionsStyles = (0, system_1.makeStyles)({
    actionsCell: {
        position: 'relative',
        paddingTop: 0,
        paddingBottom: 0,
    },
    actions: {
        // чтобы колонка с экшенами всегда имела ширину и не схлопывалась
        opacity: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        flexWrap: 'nowrap',
        flexShrink: 0,
    },
    visible: {
        '$actions&': {
            opacity: 1,
        },
    },
});
function TableRowActions(_a) {
    var children = _a.children, className = _a.className, props = __rest(_a, ["children", "className"]);
    var _b = useActionsStyles(), actionsCell = _b.actionsCell, actions = _b.actions, visible = _b.visible;
    var rowContext = (0, react_1.useContext)(RowContext);
    return (react_1.default.createElement(TableCell, __assign({}, props, { className: (0, utils_1.cn)(className, actionsCell), variant: "body", verticalAlign: "middle" }),
        react_1.default.createElement("div", { className: (0, utils_1.cn)(actions, (rowContext === null || rowContext === void 0 ? void 0 : rowContext.hover) ? visible : undefined) }, children)));
}
exports.TableRowActions = TableRowActions;
